export default class CookieStorage {

  static $inject = [
    '$cookies',
    '$window',
  ];

  constructor($cookies, $window) {
    this.$cookies = $cookies;
    this.$window = $window;

    if (!this.isAvailable()) {
      return { available: false };
    }

    this.available = true;
  }

  isAvailable() {
    return navigator.cookieEnabled;
  }

  reset() {
    // Filter out non-related cookies
    const cookies = _.pickBy(this.$cookies.getAll(), (value, key) => (key.indexOf(this.prefix()) > -1));

    _.forIn(cookies, (value, key) => {
      this.$cookies.remove(key);
    });
  }

  set(key, value) {
    value = (() => {
      if (_.isArray(value) && value.length >= 5) {
        // Use split for large arrays to reduce size when encoding
        return `array|${value.join(',')}`;
      } else if (_.isObject(value) || _.isArray(value)) {
        return JSON.stringify(value);
      }
      return value;
    })();
    return this.$cookies.put(this.prefix() + key, value);
  }

  get(key, otherwise = null) {
    if (!this.has(key)) {
      return otherwise;
    }

    const value = this.$cookies.get(this.prefix() + key);

    return this.decodeValue(value);
  }

  has(key) {
    return !!this.$cookies.get(this.prefix() + key);
  }

  remove(key) {
    if (this.has(key)) {
      this.$cookies.remove(this.prefix() + key);
    }
  }

  all() {
    // Filter out non-related cookies, then remove prefix from keys and unserialize values
    let cookies = this.$cookies.getAll();
    cookies = _.pickBy(cookies, (value, key) => (key.indexOf(this.prefix()) > -1));
    cookies = _.mapKeys(cookies, (value, key) => (key.replace(this.prefix(), '')));
    cookies = _.mapValues(cookies, this.decodeValue);

    return cookies;
  }

  decodeValue(value) {
    try {
      return JSON.parse(value);
    } catch (e) {
      if (value.indexOf('array|') === 0) {
        value = value.replace('array|', '').split(',');
      }

      return value;
    }
  }

  prefix() {
    return `_patient.${this.name()}.`;
  }

  name() {
    return 'cookie';
  }
}

CookieStorage.$inject = [
  '$cookies',
  '$window',
];

module.exports = CookieStorage;



// WEBPACK FOOTER //
// ./main/providers/cookie-storage.js